import { 
  SET_FOOTER_MODAL, SET_SLIDING_PANEL, SET_PROGRESS_MODAL, SET_DELETE_MODAL, 
  SET_UNAUTH_MODAL, SET_NONREFUND_MODAL, SET_EXPIRED_MODAL, SET_LOCKIN_MODAL,
  SET_INCLUDE_MODAL, SET_PLANNER_MODAL 
} from '../actions/types';
import update from 'immutability-helper';

const initialState = {
  isOpen:false,
  link:"",
  progressModalIsOpen:false,
  deleteModalIsOpen:false,
  unauthModalIsOpen:false,
  nonRefundModalIsOpen:false,
  expiredModalIsOpen:false,
  lockinModalIsOpen:false,
  includeModal:{ isOpen:false, id:null },
  plannerModal:{ isOpen:false, id:null }
}

export function ToggleModal(state = initialState, action){
  switch (action.type) {
    case SET_FOOTER_MODAL:
      return update(state, {
        isOpen:{$set:action.payload.isOpen},
        link:{$set:action.payload.link}
      });

    case SET_PROGRESS_MODAL:
        return update(state, {progressModalIsOpen:{$set:action.payload}});

    case SET_DELETE_MODAL:     
      return update(state, {deleteModalIsOpen:{$set:action.payload}});

    case SET_UNAUTH_MODAL:
        return update(state, {unauthModalIsOpen:{$set:action.payload}});

    case SET_NONREFUND_MODAL:
        return update(state, {nonRefundModalIsOpen:{$set:action.payload}});     

    case SET_EXPIRED_MODAL:
        return update(state, {expiredModalIsOpen:{$set:action.payload}});          
    
    case SET_LOCKIN_MODAL:
        return update(state, {lockinModalIsOpen:{$set:action.payload}});       
    
    case SET_INCLUDE_MODAL:
        return update(state, {includeModal:{$set:action.payload}});      

    case SET_PLANNER_MODAL:    
      return update(state, {plannerModal:{$set:action.payload}});      
    default:
      return state;
  }
}


const initialSlidePanel = {
  tripIsOpen:false,
  builderIsOpen:false,
  itineraryIsOpen:false
}

export function ToggleSlidePanel(state = initialSlidePanel, action){
  switch(action.type){
    case SET_SLIDING_PANEL:
        return update(state, {
          tripIsOpen:{$set:action.payload.trip},
          builderIsOpen:{$set:action.payload.builder},
          itineraryIsOpen:{$set:action.payload.itinerary}
        });
    default:
      return state;  
  }
}